import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { smallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { css } from "styled-components";

smallHeadingAndTextStyles.wrapper = {
    css: css`
        // display: -webkit-box;
        display: flex;
        flex-direction: row;
        width: 100%;

        @media print {
            display: block;
        }
    `,
};
smallHeadingAndTextStyles.heading = {
    variant: "legend",
    size: 14,
    css: css`
        display: flex;
        align-items: center;
    `,
};
smallHeadingAndTextStyles.text = {
    size: 14,
    css: css`
        width: auto;
        ${wrapInContainerStyles}
    `,
};
